import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchOffers } from "store/actions/offerActions";
import Offers from "./WaiterMenu/Offers";
import WaiterResturants from "./WaiterRestaurants";
import { useLocation } from "react-router-dom";
import { getRestaurantsAction } from "store/actions/restaurantAction";
import { fetchMenus } from "store/actions/menuActions";
import { getTableData } from "store/actions/tableActions";

const Menu = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { menus } = useSelector((state) => state.menus);
  const { offers } = useSelector((state) => state.offer);

  const [showCart, setShowCart] = useState(false);
  const [isLoadingMenu, setIsLoadingMenu] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const isCartOpen = searchParams.get("cart") === "true";
    setShowCart(isCartOpen);
  }, [location.search]);

  useEffect(() => {
    if (user?.restaurantID) {
      setIsLoadingMenu(true);
      dispatch(getRestaurantsAction(user?.restaurantID));
      dispatch(fetchOffers(user?.restaurantID));
      dispatch(getTableData(user?.restaurantID));
      const unsubscribe = dispatch(
        fetchMenus(user?.restaurantID, () => {
          setIsLoadingMenu(false);
        })
      );

      return () => {
        if (unsubscribe) unsubscribe();
      };
    }
  }, [user?.restaurantID]);

  return (
    <>
      <Card className="bg-white shadow-lg">
        <WaiterResturants menus={menus} loadingMenu={isLoadingMenu} />
      </Card>

      {!showCart && offers && offers?.length > 0 && (
        <Card className="mt-5 py-4 shadow-lg bg-white">
          <Offers offers={offers} />
        </Card>
      )}
    </>
  );
};

export default Menu;
